import React from 'react';
import HeroSection from '../components/landing/HeroSection';
import ProblemSection from '../components/landing/ProblemSection';
import CostSection from '../components/landing/CostSection';
import SolutionSection from '../components/landing/SolutionSection';
import MatrixSection from '../components/landing/MatrixSection';
import HopeSection from '../components/landing/HopeSection';
import TestimonialsSection from '../components/landing/TestimonialsSection';
import RogerVideoSection from '../components/landing/RogerVideoSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import ProgramSection from '../components/landing/ProgramSection';
import PainPointsSection from '../components/landing/PainPointsSection';
import BrainImpactSection from '../components/landing/BrainImpactSection';
import PricingSection from '../components/landing/PricingSection';
import FAQSection from '../components/landing/FAQSection';
import FinalCTASection from '../components/landing/FinalCTASection';
import Footer from '../components/landing/Footer';
import Navigation from '../components/landing/Navigation';
import PrinciplesFloatingButton from '../components/landing/PrinciplesFloatingButton';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#efede6]">
      <Navigation />
      <HeroSection />
      <ProblemSection />
      <CostSection />
      <SolutionSection />
      <MatrixSection />
      <HopeSection />
      <TestimonialsSection />
      <RogerVideoSection />
      <HowItWorksSection />
      <ProgramSection />
      <PainPointsSection />
      <PricingSection />
      <BrainImpactSection />
      <FAQSection />
      <FinalCTASection />
      <Footer />
      <PrinciplesFloatingButton />
    </div>
  );
};

export default LandingPage;
